import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Link } from "react-router-dom"

import { actions as appActions } from "../../modules/appModule"
import { actions as nexusActions } from "../../modules/nexusModule"
import { actions as userActions } from "../../modules/userModule"
import { BASE, COLOR, JARGON, MONITORING, PATH } from "../../modules/constants"
import LoginForm from "../../forms/LoginForm"
import AnonPage, { Content } from "../../components/AnonPage"
import Navbar from "../../components/layout/DashboardNavbar"
import Footer from "../../components/Footer"

import RefreshIcon from "@mui/icons-material/Refresh"

class Login extends Component {

  componentDidMount() {
    // console.log("componentDidMount() this.props: ", this.props)
    this.props.app.setPage(this.constructor.name)
  }

  render() {
    // console.log('this.props:', this.props)
    const { app, loginError, loginUrl, nexus, page, portrait, the350club, urlSource, urlTrial, user } = this.props

    return (
      <React.Fragment>
        <Navbar
          icon={<RefreshIcon />}
          page={page}
          backLink
          portrait={portrait}
        />

        <AnonPage>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper">
                  <p className="anon-short-title">Login to Numerable</p>

                  <p className="anon-sub-title">
                    subscribed and trial users can access listed company data, save favourites, set up news alerts and more
                  </p>
                  <br />

                  {the350club &&
                    <React.Fragment>
                      <p className="anon-sub-title">
                        Numerable has a user account system that is separate from that of 350 Club
                      </p>
                      <br />
                    </React.Fragment>
                  }

                  <LoginForm
                    onSubmit={form => {
                      const path = the350club ? `/${PATH[BASE.LSE.COMPANIES]}/?source=${JARGON.THE350CLUB}` : loginUrl
                      app.login({ form, path, the350club, urlTrial })
                      // Reset the nexus data because the new user may or may not have access to props such as PSCs
                      if (!the350club && !urlTrial)
                        nexus.initData()

                      // Reset the user monitoring config so that the local state searchTerms
                      // are refreshed from props.userMonitoring.SearchTerms
                      user.updateUserMonitoringConfig(
                        {
                          Categories: null,
                          Enabled: false,
                          SearchTerms: Array(MONITORING.NUM_SEARCH_TERMS).fill(''),
                        }
                      )
                    }}
                  />

                  <p className="error-message">
                    {loginError}
                  </p>

                  <p className="alternative-link" style={{ fontSize: "18px", fontWeight: "bold" }}>
                    <Link to={`/${PATH.REGISTER}`} style={{ color: COLOR.BRAND.STD }} >No account? Register</Link>
                  </p>

                  <p className="alternative-link">
                    <Link to={`/${PATH.T_AND_C}`} style={{ color: COLOR.BRAND.STD }} >Web App Terms and Conditions</Link>{", "}
                    <Link to={`/${PATH.PRIVACY}`} style={{ color: COLOR.BRAND.STD }} >Privacy Policy</Link>
                  </p>
                </div>
              </div>
            </div>
          </Content>

        </AnonPage>

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    loginError: app.loginError,
    portrait: user.portrait,
    the350club: common.the350club,
    urlSource: common.urlSource,
    urlTrial: common.urlTrial,
    loginUrl: common.loginUrl,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
    nexus: bindActionCreators(nexusActions, dispatch),
    user: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)

